module.exports = __webpack_public_path__ + "img/reference62.d0b36cb1.jpg";